import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";

import cancelbutton from "../../../Assets/Cancel.svg";
import "./model.css";
import MenuItem from '@mui/material/MenuItem';

const roles = [
  "Admin","Employee"
];
const AddEmployee = (props) => {



  
  // console.log(props.row);
  const [data, setdata] = useState({
    Employee_Name: props.what == "Edit" ? props.row[1] : "",
    Contact_Number: props.what == "Edit" ? props.row[2] : "",
    Email_Address: props.what == "Edit" ? props.row[3] : "",
    Roles: props.what == "Edit" ? props.row[6] : "",
    User_Name: props.what == "Edit" ? props.row[4] : "",
    Pass_word: props.what == "Edit" ? props.row[5] : "",
    Permissions: "view",
  });
  const addvalues = (e) => {
    if(e.target.name=="Roles")
      {
        setdata({ ...data, [e.target.name]: e.target.value,Permissions: "view,edit,delete"});
      }
      else{
        setdata({ ...data, [e.target.name]: e.target.value})

      }
  };


  const [idselected, setidselected] = useState();
  const [tableName, settablename] = useState("employees_data");
  
  console.log("Data is", data);
  console.log("Data is", data);
  
  const [mail,setmail]=useState(true)
  const [data2,setdata2]=useState({
    mail:"harsh@gma.com"
  })
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("===============data to be Added", data);

    if(data.Contact_Number!=""&&data.Email_Address!=""&&data.Employee_Name!=""&&data.Pass_word!=""&&data.Permissions!=""&&data.Roles!=""&&data.User_Name!="")
      {
    try {
      console.log("+insdide try");
      const response = await fetch(
        "https://policydekhoo-backend.onrender.com/Setemployeesdata",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      if (response.ok) {
        
        console.log("Data added successfully");
        props.dataAdd(data)
        // props.handleClose()

      } else {
        console.error("Failed to add data");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
  };
  
const validateNumber=(event)=>{

    const { value } = event.target;

    const isnot = /^[0-9]*$/.test(event.key);
    const isnot2 = /^$/.test(event.key);
    if (isnot || isnot2) {
      
    } else {
      event.preventDefault();
    }
 
}
const validatealpha=(event)=>{

  const { value } = event.target;

  const isnot = /^[A-Za-z]*$/.test(event.key);
  const isnot2 = /^$/.test(event.key);
  if (isnot || isnot2) {
    
  } else {
    event.preventDefault();
  }

}
const validateusername=(event)=>{

  const { value } = event.target;

  const isnot = /^[A-Za-z._0-9]*$/.test(event.key);
  const isnot2 = /^$/.test(event.key);
  if (isnot || isnot2) {
    
  } else {
    event.preventDefault();
  }

}
const validatemail = (e) => {
  const inputEmail = e.target.value;

  // Regular expression for email validation
  const emailRegex = /^([a-z0-9._]+\@[a-z]+\.[a-z]+)$/;
  setmail(emailRegex.test(inputEmail));
};

  const handleSubmit2 = async (id,e) => {
    e.preventDefault();
    // console.log("===============data to be updated and id", data, id);
    if(data.Contact_Number!=""&&data.Email_Address!=""&&data.Employee_Name!=""&&data.Pass_word!=""&&data.Permissions!=""&&data.Roles!=""&&data.User_Name!="")
      {
        try {
          setidselected(id); // Set the ID first
          const response = await fetch(
            `https://policydekhoo-backend.onrender.com/Updatedata?tableName=${tableName}&id=${id}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );
      
          if (response.ok) {
            props.dataUpdate(data,id) 
            console.log("Data updated successfully");
            props.handleClose()
          } else {
            console.error("Failed to update data");
          }
        } catch (error) {
          console.error("Error:", error);
        }
      }
  };

  return (
    <div className="model">
      <div className="row m-3 my-4 align-items-center justify-content-center">
        <div className="col">
          <h3>{props.what} User</h3>
        </div>
        <div className="col-1 me-3 me-md-1" onClick={props.handleClose}>
          <img
            src={cancelbutton}
            className=" pointer-cursor"
            width={20}
            alt="close"
          />
        </div>
      </div>
      <form>
        <div className="row m-3 ">
          <div className="col  my-3 my-md-0">
            {props.what === "Add" && (
              <TextField
                id="outlined-basic"
                name="Employee_Name"
                value={data.Employee_Name}
                onChange={addvalues}
                label="Name"
                inputProps={{maxLength:30}}
                onKeyPress={validatealpha}
                placeholder="Enter Name of Employee"
                fullWidth
                variant="outlined"
                required
              />
            )}

            {props.what === "Edit" && (
              <TextField
                id="outlined-basic"
                label="Name"
               
                inputProps={{maxLength:30}}
                onKeyPress={validatealpha}
                value={data.Employee_Name}
                name="Employee_Name"
                onChange={addvalues}
                placeholder="Enter Name of Employee"
                fullWidth
                variant="outlined"
                required
              />
            )}
          </div>
        
          <div className="col my-3 my-md-0">
            {props.what === "Add" && (
              <TextField
                id="outlined-basic"
                name="Contact_Number"
                value={data.Contact_Number}
                onChange={addvalues}
                onKeyPress={validateNumber}
                inputProps={{maxLength:10}}
                label="Contact no."
                placeholder="xxx-xxx-xxxx"
                fullWidth
                required
                variant="outlined"
              />
            )}

            {props.what === "Edit" && (
              <TextField
                id="outlined-basic"
                value={data.Contact_Number}
                name="Contact_Number"
                onKeyPress={validateNumber}
                inputProps={{maxLength:10}}
                onChange={addvalues}
                label="Contact no."
                placeholder="xxx-xxx-xxxx"
                fullWidth
                required
                variant="outlined"
              />
            )}
          </div>
        </div>
        <div className="row m-3 d-block d-md-flex ">
          
          <div className="col my-3 my-md-0">
            {props.what === "Add" && (
              <TextField
                id="outlined-basic"
                name="Email_Address"
                onKeyPress={validatemail}
                value={data.Email_Address}
                required
                error={mail?false:true}
                type="email"
                inputProps={{maxLength:30}}
                onChange={addvalues}
                label="Email"
                placeholder="Enter email"
                fullWidth
                variant="outlined"
                helperText={mail?"":"Invalid mail"}
              />
            )}

            {props.what === "Edit" && (
              <TextField
                id="outlined-basic"
                value={data.Email_Address}
                type="email"
                inputProps={{maxLength:30}}
                name="Email_Address"
                onChange={addvalues}
                label="Email"
                required
                placeholder="Enter email"
                fullWidth
                variant="outlined"
              />
            )}
          </div>
          <div className="col my-3 my-md-0">
            {props.what === "Add" && (
              <TextField
              id="outlined-select-currency"
              select
              placeholder="Select Role"
              value={data.Roles}
              name="Roles"
              required
              onChange={addvalues}
              fullWidth
              label="Role"
            >
              {roles.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            )}

            {props.what === "Edit" && (
              <TextField
              id="outlined-select-currency"
              select
              placeholder="Select Role"
              value={data.Roles}
              required
              name="Roles"
              onChange={addvalues}
              fullWidth
              label="Role"
            >
              {roles.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            )}
          </div>
        </div>
        <div className="row m-3 d-block d-md-flex">
          <div className="col my-3 my-md-0">
            {props.what === "Add" && (
              <TextField
                id="outlined-basic"
                name="User_Name"
                value={data.User_Name}
                required
                onKeyPress={validateusername}
                inputProps={{maxLength:30}}
                onChange={addvalues}
                label="Username"
                placeholder="Enter Username"
                fullWidth
                variant="outlined"
              />
            )}

            {props.what === "Edit" && (
              <TextField
                id="outlined-basic"
                value={data.User_Name}
                inputProps={{maxLength:30}}
                onKeyPress={validateusername}
                name="User_Name"
                onChange={addvalues}
                label="Username"
                required
                placeholder="Enter Username"
                fullWidth
                variant="outlined"
              />
            )}
          </div>
          <div className="col my-3 my-md-0">
            {props.what === "Add" && (
              <TextField
                id="outlined-basic"
                name="Pass_word"
                onChange={addvalues}
                value={data.Pass_word}
                inputProps={{minLength:6,maxLength:20}}
                required
                type="password"
                label="Password"
                placeholder="Enter Password"
                fullWidth
                variant="outlined"
              />
            )}

            {props.what === "Edit" && (
              <TextField
                id="outlined-basic"
                value={data.Pass_word}
                name="Pass_word"
                onChange={addvalues}
                inputProps={{minLength:6,maxLength:20}}
                required
                type="password"
                label="Password"
                placeholder="Enter Password"
                fullWidth
                variant="outlined"
              />
            )}
          </div>
        </div>
        <div className="row justify-content-center my-4">
          <div className="col text-center">
            {props.what === "Add" && (
              <button
                className="accepted-bg px-3 p-1 rounded border-0"
                onClick={(e) => {
                  handleSubmit(e);
                }}
               
              >
                {props.what} users
              </button>
            )}

            {props.what === "Edit" && (
              <button
                className="accepted-bg px-3 p-1 rounded border-0"
                onClick={(e) => handleSubmit2(props.row[0],e)}
              >
                {props.what} users
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddEmployee;
